var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowMini(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53015 6.03082C9.6706 5.8902 9.74949 5.69957 9.74949 5.50082C9.74949 5.30207 9.6706 5.11145 9.53015 4.97082L5.53015 0.970823C5.38953 0.830372 5.1989 0.751482 5.00015 0.751482C4.8014 0.751482 4.61078 0.830372 4.47015 0.970823L0.470153 4.97082C0.396466 5.03948 0.337364 5.12229 0.296372 5.21428C0.25538 5.30628 0.233339 5.4056 0.231562 5.5063C0.229785 5.607 0.24831 5.70703 0.286031 5.80042C0.323752 5.89381 0.379896 5.97864 0.451115 6.04986C0.522334 6.12108 0.607168 6.17722 0.700556 6.21495C0.793944 6.25267 0.893973 6.27119 0.994676 6.26941C1.09538 6.26764 1.19469 6.2456 1.28669 6.2046C1.37869 6.16361 1.46149 6.10451 1.53015 6.03082L5.00015 2.56082L8.47015 6.03082C8.61078 6.17127 8.8014 6.25016 9.00015 6.25016C9.1989 6.25016 9.38953 6.17127 9.53015 6.03082Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowMini);
export default __webpack_public_path__ + "static/media/arrowMini.2984a69a1329c0bc21a3470a81a94432.svg";
export { ForwardRef as ReactComponent };